import {Component, OnInit} from '@angular/core';
// @ts-ignore
import moment from 'moment';
import {timeInterval, openingDate} from '../time.model';

@Component({
  selector: 'visit-card',
  templateUrl: './visit-card.component.html',
  styleUrls: ['./visit-card.component.sass']
})
export class VisitCardComponent implements OnInit {

  selectedIndex=-1;

  constructor() {

  }

  getTimeInterval(){
    return timeInterval;
  }

  selectIndex(index, event){
    if(this.selectedIndex==index){
      this.selectedIndex=-1;
    }else{
      this.selectedIndex=index;
    }
    this.stopPropagation(event)
  }

  stopPropagation(event:any){
    event.stopPropagation();
  }


  ngOnInit() {
    document.onclick=()=>{
      this.selectedIndex=-1;
    }
  }

  isToday(dayofWeek:number):boolean{
    return dayofWeek=== moment().weekday();
  }


  getStatus(): any {
    //const now =  moment('2020-06-25 17:30'); // moment();


    let open: boolean=false;
    let status='';
    const now =  moment();

   /* if(openingDate && now.isBefore(openingDate)){
      const mom=moment(openingDate);
      status='öffnet am ' + mom.format('MM.YYYY');
      // console.log(mom.weekday());
      let found = timeInterval.find(int => int.dayOfWeek === mom.weekday());
      if(!found){
        found = this.findNextDay(mom.weekday()+1);
      }
      if(found && found.times && found.times.length > 0 && found.times[0]){
        // status='öffnet am ' + mom.format('DD.MM.YYYY')+' um '+found.times[0].from+ ' Uhr';
      }
      return {open, status}
    }*/
    const day=now.weekday();
    const found = timeInterval.find(int => int.dayOfWeek === day);


    let int1;
    let int2;
    let t1;
    let t2;
    if(found) {
      t1 = found.times[0];
      t2 = found.times[1];
      // console.log(now.toLocaleString(), " now");
      if(t1) {
        int1 = {from: this.getMoment(t1.from), to: this.getMoment(t1.to)};
      }
      if(t2) {
        int2 = {from: this.getMoment(t2.from), to: this.getMoment(t2.to)}
      }
    }
    if(!found || (int1 && int2 && now.isSameOrAfter(int2.to)) || (int1 && !int2 && now.isSameOrAfter(int1.to, 'minute'))) {
        open=false;
        const nextDay = this.findNextDay(day+1);
        if(nextDay) {
          status = 'öffnet am ' + nextDay.dayName + ' um ' + nextDay.times[0].from + ' Uhr';
        }
    }

    if(int1 && now.isBetween(int1.from, int1.to, 'minute')) {
        open=true;
        status = 'schließt um ' + t1.to + ' Uhr';
    } else if(int2 && now.isBetween(int2.from, int2.to)){
        open=true;
        status = 'schließt um ' + t2.to + ' Uhr';
    }else if(int1 && now.isBefore(int1.from, 'minute')) {
        open=false;
        status = 'öffnet um ' + t1.from + ' Uhr';
    } else if(int1 && int2 && now.isBetween(int1.to, int2.from)) {
        open=false;
        status = 'öffnet um ' + t2.from + ' Uhr';
    }
    return {open, status};
  }


  findNextDay(day: number){
    if(day>6 || day<0) day=1;
    let found = timeInterval.find(int => int.dayOfWeek === day);
    if(found && found.times && found.times.length >0 && found.times[0].from){
      return found;
    }else {
      found=this.findNextDay(day+1);
    }
    return found;
  }


  isTime(time: any){
    if(time && time.from && time.to){
      const fromDate = this.getMoment( time.from);
      const toDate = this.getMoment(time.to);
      return moment().isBetween(fromDate, toDate, 'minute');
    }
    return false;
  }


  getMoment(time: string): moment.Moment{
    const date = moment().format('yyyy-MM-DD');
    const m= moment(date + ' ' + time);
    return m;
  }



}
